/**
 * line_geometry — a `normal` for geometries that were built from points.
 *
 * With a NORMAL MRT target on the scene pass (AO, SSR) three's node material
 * writes that output for EVERY material, and the normal is read from the
 * geometry's `normal` attribute. A `THREE.Line` built with `setFromPoints`
 * has none; on Dawn the pipeline that reads a missing vertex attribute is
 * invalid, and an invalid pipeline poisons the whole command buffer it is
 * encoded into — the July 2026 black frame that had AO stripped on WebGPU
 * (render wave 1, 2026-09-17). A zero normal makes every output well-defined
 * and costs 12 bytes a vertex.
 */
import * as THREE from 'three/webgpu';

export function withLineNormals<T extends THREE.BufferGeometry>(geometry: T): T {
  if (!geometry.getAttribute('normal')) {
    const pos = geometry.getAttribute('position');
    const n = pos ? pos.count : 0;
    geometry.setAttribute('normal', new THREE.BufferAttribute(new Float32Array(n * 3), 3));
  }
  return geometry;
}
